import React from "react";
import PaginationArrow from "../../assets/svgcomps/ArrowIcon";

interface PaginationUIProps {
  pages: number[];
  currentPage: number;
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onPageClick: (page: number) => void;
}

const Pagination: React.FC<PaginationUIProps> = ({
  pages,
  currentPage,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  onPageClick,
}) => {
  return (
    <div className="flex gap-2 items-center justify-center md:justify-between font-medium">
      <div>
        <div
          className={`${
            hasPrevious
              ? "opacity-100 cursor-pointer"
              : "opacity-60 cursor-not-allowed"
          } text-sm  flex items-center gap-2`}
          onClick={hasPrevious ? onPrevious : () => {}}
        >
          <PaginationArrow fill={"black"} otherClasses="rotate-180" />
          <p> Previous</p>
        </div>
      </div>
      <div className="gap-1 flex">
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => onPageClick(page)}
            className={`px-[14px] py-[8px] rounded-md ${
              page === currentPage
                ?  "bg-gray-100 text-gray-800 border-gray-300 border-2" : ""
            }`}
          >
            {page}
          </button>
        ))}
      </div>
      <div>
        <div
          className={`${
            hasNext
              ? "opacity-100 cursor-pointer"
              : "opacity-60 cursor-not-allowed"
          } text-sm  flex items-center gap-2`}
          onClick={hasNext ? onNext : () => {}}
        >
          <p>Next</p>
          <PaginationArrow fill={"black"} />
        </div>
      </div>
    </div>
  );
};

export default Pagination;
